import React, { useEffect, useState } from "react";
import { Canvas } from "@react-three/fiber";
import { Suspense } from "react";
import { Environment } from "@react-three/drei";
import { EffectComposer, Bloom, Noise, Vignette } from "@react-three/postprocessing";
import { ACESFilmicToneMapping } from "three";

import AICore from "./AICore";
import EnergyRings from "./EnergyRings";
import BackgroundParticles from "./BackgroundParticles";
import Lights from "./Lights";
import CameraRig from "./CameraRig";
import FloatingDocuments from "./FloatingDocuments";
import WorkflowLines from "./WorkflowLines";
import WorkflowNodes from "./WorkflowNodes";
import DocumentCloud from "./DocumentCloud";

const StoryCanvas = () => {
    const [isDesktop, setIsDesktop] = useState(false);
    useEffect(() => {
        const handleResize = () => { setIsDesktop(window.innerWidth > 768); };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => { window.removeEventListener("resize", handleResize); };
    }, []);

    const cameraSettings = isDesktop
        ? { position: [0, 0, 8], fov: 45, }
        : { position: [0, 0, 12], fov: 60, };

    return (
        <div className="tw-fixed tw-inset-0 tw-pointer-events-none">
            <Canvas
                style={{ pointerEvents:"none" }}
                camera={ cameraSettings }
                dpr={ window.innerWidth < 768 ? 1 : [1,1.5] }
                gl={{
                    antialias:true,
                    toneMapping:ACESFilmicToneMapping,
                    powerPreference:"high-performance",
                }}  
            >
                <Suspense
                    fallback = {null}
                    // fallback = {
                    //     <div className="tw-fixed tw-inset-0 tw-bg-[#020617]" />
                    // }
                >
                    {/* Camera movement controller */}
                    <CameraRig />

                    {/* Cinematic lighting */}
                    <Lights />
                    {/* <ambientLight intensity={0.4} /> */}
                    {/* <directionalLight
                        position={[5, 5, 5]}
                        intensity={1.5}
                    /> */}

                    <FloatingDocuments />

                    {/* Floating ambient particles */}
                    <BackgroundParticles />

                    <group scale = { isDesktop ? 1 : 0.65 }>
                        <WorkflowLines />

                        <WorkflowNodes />

                        <DocumentCloud />

                        {/* Future AI operating system core */}
                        <AICore />

                        <EnergyRings />
                    </group>

                    {isDesktop && (
                        // Real world environment reflections
                        <Environment preset="city" environmentIntensity={0.5} />
                    )}

                    { isDesktop && (
                        // Premium visual effects
                        <EffectComposer>
                            <Bloom
                                intensity={1.2}
                                luminanceThreshold={0.25}
                                luminanceSmoothing={0.9}
                                mipmapBlur
                            />

                            <Noise opacity={0.025} />

                            <Vignette
                                eskil={false}
                                offset={0.2}
                                darkness={0.8}
                            />
                        </EffectComposer>
                    )}
                </Suspense>
            </Canvas>
        </div>
    );
};

export default StoryCanvas;
